(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-tables-retailer"] && !window.DesignMode) return;
  try {
    
  
  function equalizeComparisonTables() {
    const sections = document.querySelectorAll('.js-comparison-table')
  
    sections.forEach((section) => {
      const sides = section.querySelectorAll('.js-comparison-table-section');
      let tables = [];
  
      sides.forEach((section, index) => {
        let group = [];
        section.querySelectorAll('.js-checklist-wrapper').forEach((wrapper, index) => {
  
          wrapper.querySelectorAll('.checklist ul').forEach((list) => {
            if(list.offsetParent != null) {
              group[index] = list;
            }
          })
        })
  
        tables.push(group)
      })
  
      tables[0].forEach((table, index) => {
        equalizeListHeights(tables[0][index], tables[1][index]);
      })
    })
  }
  
  function equalizeListHeights(list1, list2) {
  
      if (list1 && list2) {
        const items1 = list1.querySelectorAll('li');
        const items2 = list2.querySelectorAll('li');
  
        // ideally the lists are the same length but just to be safe
        items1.forEach((item, index) => {
          
          if(items2[index]) {
            item.style.minHeight = 'auto';
            items2[index].style.minHeight = 'auto';
   
            const height1 = item.clientHeight;
            const height2 = items2[index].clientHeight;
            const maxHeight = Math.max(height1, height2);
  
            item.style.minHeight = `${maxHeight}px`;
            items2[index].style.minHeight = `${maxHeight}px`;
          }
        });
      }
    }
  
    window.addEventListener('load', () => {
      equalizeComparisonTables();
    })
  
    window.addEventListener('resize', () => {
      debounce(equalizeComparisonTables(), 100);
    })
  
    $(function() {
      $('.js-mh').matchHeight();
      $('.js-table-outer').matchHeight();
    });
  
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-tables"] && !window.DesignMode) return;
  try {
    

function equalizeComparisonTables() {
  const sections = document.querySelectorAll('.js-comparison-table')

  sections.forEach((section) => {
    const sides = section.querySelectorAll('.js-comparison-table-section');
    let tables = [];

    sides.forEach((section, index) => {
      let group = [];
      section.querySelectorAll('.js-checklist-wrapper').forEach((wrapper, index) => {

        wrapper.querySelectorAll('.checklist ul').forEach((list) => {
          if(list.offsetParent != null) {
            group[index] = list;
          }
        })
      })

      tables.push(group)
    })

    tables[0].forEach((table, index) => {
      equalizeListHeights(tables[0][index], tables[1][index]);
    })
  })
}

function equalizeListHeights(list1, list2) {

    if (list1 && list2) {
      const items1 = list1.querySelectorAll('li');
      const items2 = list2.querySelectorAll('li');

      // ideally the lists are the same length but just to be safe
      items1.forEach((item, index) => {
        
        if(items2[index]) {
          item.style.minHeight = 'auto';
          items2[index].style.minHeight = 'auto';
 
          const height1 = item.clientHeight;
          const height2 = items2[index].clientHeight;
          const maxHeight = Math.max(height1, height2);

          item.style.minHeight = `${maxHeight}px`;
          items2[index].style.minHeight = `${maxHeight}px`;
        }
      });
    }
  }

  window.addEventListener('load', () => {
    equalizeComparisonTables();
  })

  window.addEventListener('resize', () => {
    debounce(equalizeComparisonTables(), 100);
  })

  $(function() {
    $('.js-mh').matchHeight();
    $('.js-table-outer').matchHeight();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-subscription"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sl-offer-bar"] && !window.DesignMode) return;
  try {
    
    window.addEventListener('load', (event) => {
        const thisBar = document.querySelector('.shoplift-offer--bar--sticky');

        if (thisBar != null) {
            const thisHeader = document.querySelector('.shoplift-offerbar-wrapper');
            thisHeader.classList.add("shoplift-offer-bar-sticky");

            const mainHeader = document.querySelector('#shopify-section-header > sticky-header');

            const mainInitialTop = mainHeader.offsetTop;
            const stickyStart = mainHeader ? (mainHeader.offsetTop + mainHeader.clientHeight) : 0;
            let lastScroll = window.scrollY;
            document.addEventListener("scroll", (scrollEvent) => {
                if (!thisHeader) return;

                // Do it quick and dirty
                const mainHidden = mainHeader && (window.scrollY > lastScroll);
                lastScroll = window.scrollY;

                const makeSticky = window.pageYOffset > stickyStart || mainHeader && window.pageYOffset > mainInitialTop && mainHeader.parentElement.classList.contains("shopify-section-header-sticky");

                thisHeader.classList.toggle("shoplift-offer-bar-sticky", makeSticky);

                if (!makeSticky) return;

                let topPosition = 0;

                if (mainHeader && !mainHidden)
                    topPosition += mainHeader.clientHeight;

                thisHeader.style.top = topPosition + "px";
            });
        }
    });

  } catch(e) { console.error(e); }
})();
})();
